import { render, staticRenderFns } from "./barra.vue?vue&type=template&id=e0717bd2&scoped=true"
import script from "./barra.vue?vue&type=script&lang=js"
export * from "./barra.vue?vue&type=script&lang=js"
import style0 from "./barra.vue?vue&type=style&index=0&id=e0717bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0717bd2",
  null
  
)

export default component.exports